/* eslint-disable sort-keys*/
import rem from './rem';
const spacingBase = 4;
const spacing = {
    none: 0,
    base: rem(spacingBase),
    x2: rem(spacingBase * 2),
    x3: rem(spacingBase * 3),
    x4: rem(spacingBase * 4),
    x5: rem(spacingBase * 5),
    x6: rem(spacingBase * 6),
    x8: rem(spacingBase * 8),
    x10: rem(spacingBase * 10),
    x12: rem(spacingBase * 12),
    x16: rem(spacingBase * 16), // 64
};
export default spacing;
